import React, { useRef } from 'react';
import Box from '@mui/material/Box';
import grey from '@mui/material/colors/grey';
import Typography from '@mui/material/Typography';
import parse from 'html-react-parser';
import MapLegend from './MapLegend';
import { operatorName, variableName, gridSmryName, gridName } from "../js/constants";
import { formatDateRange } from "../js/utilityRoutines";

export default function GridmapMap(props) { 
  const { userParams, results } = props;
  const elementRef = useRef(null);
  const dateRange = "<br />" + formatDateRange(userParams).replace(".","");
  const titleText = gridSmryName[userParams.smry] + " " + variableName[userParams.variable].name + " " + 
    (!['max','min','mean','sum'].includes(userParams.smry) 
    ? (operatorName[userParams.operator] + " " + userParams.thresh + " " + variableName[userParams.variable].units) 
    : "(" + variableName[userParams.variable].units + ")"
    ) 
    + dateRange
    + "<br />Grid: " + gridName[userParams.grid];
  const haveMap = results.histogram.reduce((a, b) => a + b, 0) > 0;   //sum of histogram to determine when map is not empty

  return (
    <>
      {haveMap 
        ?
          <Box justifyContent="center" alignItems="center" sx={{ mt: 1, border:"1pt solid " + grey[500]}} ref={elementRef}>
            <Typography 
              align="center" 
              variant="subtitle1"
              sx={{ my: 1 }}
            >
              {parse(titleText)}
            </Typography>
            <img src={results.data} style={{height:Math.min(...results.size), display:"block", marginLeft:"auto", marginRight:"auto"}} alt="requested map"></img>
            <MapLegend
              userParams={userParams}
              results={results}
            />
          </Box>
        :
          <Typography sx={{color: "red"}}>
              Specified map unavailable.
          </Typography>
      }
    </>
  )
} 